import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  CircularProgress,
  TextField,
  Chip,
  Stack
} from "@mui/material";
import { userService } from "../service/UserService";

const User = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // 🔄 Fetch users
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await userService.getAllUsers();
      setUsers(res || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // 🔍 Search filter
  const filteredUsers = users.filter(
    (u) =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase()) ||
      u.mobile.includes(search)
  );

  // 🔥 Approve toggle
  const handleApprove = async (id, currentStatus) => {
    try {
      await userService.approveUser(id, {
        AdminApproval: !currentStatus
      });
      fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box p={2}>
      {/* HEADER */}
      <Typography variant="h4" mb={2}>
        User Management
      </Typography>

      {/* SEARCH + ACTION */}
      <Stack direction="row" spacing={2} mb={2}>
        <TextField
          fullWidth
          placeholder="Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Button variant="contained">SEARCH</Button>
      </Stack>

      {/* TABLE */}
      <Paper elevation={3}>
        <Table>
          <TableHead sx={{ background: "#f5f5f5" }}>
            <TableRow>
              <TableCell><b>Name</b></TableCell>
              <TableCell><b>Email</b></TableCell>
              <TableCell><b>Mobile</b></TableCell>
              <TableCell><b>Role</b></TableCell>
              <TableCell><b>Location</b></TableCell>
              <TableCell><b>Status</b></TableCell>
              <TableCell><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredUsers.map((user) => (
              <TableRow key={user._id} hover>

                <TableCell>{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.mobile}</TableCell>

                {/* ROLE BADGE */}
                <TableCell>
                  <Chip
                    label={user.role}
                    color={user.role === "ADMIN" ? "error" : "default"}
                  />
                </TableCell>

                <TableCell>{user.location}</TableCell>

                {/* STATUS BADGE */}
                <TableCell>
                  <Chip
                    label={user.AdminApproval ? "Approved" : "Pending"}
                    color={user.AdminApproval ? "success" : "warning"}
                  />
                </TableCell>

                {/* ACTION BUTTON */}
                <TableCell>
                  <Button
                    variant="contained"
                    size="small"
                    color={user.AdminApproval ? "error" : "success"}
                    onClick={() =>
                      handleApprove(user._id, user.AdminApproval)
                    }
                  >
                    {user.AdminApproval ? "Revoke" : "Approve"}
                  </Button>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default User;